import * as React from 'react';
import {Popover, Tooltip, Button, Modal, OverlayTrigger, Table, FormGroup, FormControl, Form} from "react-bootstrap";
import {SearchResult} from "./search";
import {FrameMeta} from "../problem-domain/frame";
import {renderPath} from "./utils";
import {CurrentLexiconData} from "./LexiconPage";
import {RouteComponentProps} from "react-router";


export namespace ComparePopup {
    export interface Props {
        frameIndex: FrameMeta,
        currentLexicon: CurrentLexiconData,
        style: any,
        history: any
    }
}

export class ComparePopupSelect extends React.Component<ComparePopup.Props, any> {
    constructor(props, context) {
        super(props, context);

        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);

        this.state = {
            show: false,
            showAll: false,
            search: ""
        };
    }

    handleClose() {
        this.setState({show: false});
    }

    handleShow() {
        this.setState({show: true});
    }

    renderRow(path: string[]) {
        const lexicon = path.slice(-1)[0];
        return (<tr>
            <td><a style={{"cursor": "pointer"}}
                   onClick={() => {
                       this.props.history.push("/comparison/" + path.join("/") + ":/" + this.props.currentLexicon.path.join("/"));
                   }}>{lexicon}</a></td>
            <td>{renderPath(path, this.props.frameIndex, true, true)}</td>
        </tr>);
    }

    handleSubmit(event) {
    }

    render() {
        let basePath = this.props.currentLexicon.path.slice(0, -2);
        console.log(basePath);
        let baseIndex = this.props.frameIndex.find(basePath)!;
        let lexicons = SearchResult.findMatchedLexicons(baseIndex, basePath, this.state.search);
        if (!this.state.showAll) {
            lexicons = lexicons.slice(0, 3);
        }

        return (
            <div style={this.props.style}>
                <Button bsStyle="primary" onClick={this.handleShow}>Compare</Button>

                <Modal show={this.state.show} onHide={this.handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Compare Lexicons...</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <h4>Select a lexicon to compare</h4>
                        <Form onSubmit={this.handleSubmit.bind(this)} inline>
                            <FormGroup>
                                <FormControl type="text"
                                             placeholder="filter"
                                             onChange={(e) => {
                                                 this.setState({search: (e as any).target.value, showAll: false})}}
                                             />
                            </FormGroup>
                        </Form>
                        <Table striped bordered condensed hover>
                            <thead>
                            <tr>
                                <th>Name</th>
                                <th>Frame</th>
                            </tr>
                            </thead>
                            <tbody>
                            {lexicons.map(x => this.renderRow(x))}
                            </tbody>
                        </Table>
                    </Modal.Body>
                    {(!this.state.showAll) &&
                    <a onClick={() => {
                        this.setState({showAll: true})
                    }}>Show all...</a>
                    }
                    <Modal.Footer>
                        <Button onClick={this.handleClose}>Close</Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/compare-popup.tsx